import React from "react";
import { SettingsPageLayout as Layout } from "Containers/Settings/SettingsHub/SettingsPageLayout";
import { lazyLoader } from "Service/loader";
const UserProfile = lazyLoader(
  () => import("Containers/Settings/UserProfile/UserProfile")
);

export const SettingUserProfile = () => {
  return (
    <Layout>
      <UserProfile />
    </Layout>
  );
};
